<template>
  <div>
    <div class="flex justify-between space-x-2 py-2">
      <div class="flex items-center justify-center">
        <div
          class="relative flex size-10 items-center justify-center rounded bg-primary text-white"
          :style="
            orderItem.product?.color
              ? { backgroundColor: orderItem.product.color }
              : {}
          "
        >
          {{ shortString }}
        </div>
      </div>
      <div
        class="flex flex-1 flex-col items-start justify-around"
      >
        <div class="text-sm">
          {{ orderItem.product?.name || "Custom" }}
        </div>

        <div
          v-if="orderItem.note"
          class="line-clamp-1 text-xs text-background-fg/70"
        >
          {{ orderItem.note }}
        </div>
      </div>
      <div class="flex w-24 items-center justify-end">
        <p
          class="line-clamp-1 text-right text-sm font-semibold"
        >
          {{
            formatToMerchantCurrencyString(orderItem.price)
          }}
        </p>
      </div>
    </div>
    <ul
      v-if="orderItem.productModifierLabels?.length"
      class="rounded border p-2"
      :style="{
        borderColor: orderItem.product?.color ?? 'black',
      }"
    >
      <li
        v-for="modifier in orderItem.productModifierLabels"
        :key="modifier"
        class="text-xs text-background-fg/70"
      >
        {{ modifier }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import type { OrderDetailOrderItem } from "@/services/orders/retrieveOrder"

const props = defineProps<{
  orderItem: OrderDetailOrderItem
}>()

const { formatToMerchantCurrencyString } = useCurrency()

const shortString = computed(() => {
  return props.orderItem.product
    ? buildShortString(props.orderItem.product.name)
    : "-"
})
</script>
